import { render, staticRenderFns } from "./contentview.vue?vue&type=template&id=cdf3b700&scoped=true&"
import script from "./contentview.vue?vue&type=script&lang=js&"
export * from "./contentview.vue?vue&type=script&lang=js&"
import style0 from "./contentview.vue?vue&type=style&index=0&id=cdf3b700&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf3b700",
  null
  
)

export default component.exports